import Assembly from './Assembly';

export default Assembly;
